import { render, staticRenderFns } from "./SectionBase.vue?vue&type=template&id=0290bf2b&scoped=true"
import script from "./SectionBase.vue?vue&type=script&lang=js"
export * from "./SectionBase.vue?vue&type=script&lang=js"
import style0 from "./SectionBase.vue?vue&type=style&index=0&id=0290bf2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0290bf2b",
  null
  
)

export default component.exports